import { render, staticRenderFns } from "./resultListDialog.vue?vue&type=template&id=5832b54a&scoped=true"
import script from "./resultListDialog.vue?vue&type=script&lang=ts"
export * from "./resultListDialog.vue?vue&type=script&lang=ts"
import style0 from "./resultListDialog.vue?vue&type=style&index=0&id=5832b54a&prod&lang=less"
import style1 from "./resultListDialog.vue?vue&type=style&index=1&id=5832b54a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5832b54a",
  null
  
)

export default component.exports